import { isValidCivilDate } from './dates';

export const BALANCE_POSITION_SOURCES = Object.freeze(['manual', 'imported', 'adjustment']);

const timestampMillis = (value) => value instanceof Date ? value.getTime()
  : value && typeof value === 'object' && typeof value.toMillis === 'function' ? value.toMillis() : null;

export const parseBalancePosition = (id, raw = {}) => {
  if (!id || typeof raw.accountId !== 'string' || !raw.accountId
    || !Number.isSafeInteger(raw.amountCents) || !isValidCivilDate(raw.effectiveDate)
    || !BALANCE_POSITION_SOURCES.includes(raw.source)
    || typeof raw.createdByUid !== 'string' || !raw.createdByUid
    || timestampMillis(raw.createdAt) === null || timestampMillis(raw.updatedAt) === null
    || raw.schemaVersion !== 1) return null;
  return { id, ...raw };
};

export const selectBalancePositionAtDate = (positions, targetDate, accountId) => [...positions]
  .filter((position) => (!accountId || position.accountId === accountId) && position.effectiveDate <= targetDate)
  .sort((left, right) => right.effectiveDate.localeCompare(left.effectiveDate)
    || (timestampMillis(right.createdAt) || 0) - (timestampMillis(left.createdAt) || 0)
    || right.id.localeCompare(left.id))[0] || null;

const nextCivilDate = (value) => {
  if (!isValidCivilDate(value)) return null;
  const date = new Date(`${value}T00:00:00Z`);
  date.setUTCDate(date.getUTCDate() + 1);
  return date.toISOString().slice(0, 10);
};

export const calculateKnownBalance = ({ position, occurrences, targetDate, coverageStartDate, coverageEndDate }) => {
  if (!position) return { status: 'missing_position', position: null, amountCents: null, asOfDate: targetDate, reliableFromDate: null };
  if (position.effectiveDate > targetDate) return { status: 'position_after_period', position, amountCents: null, asOfDate: targetDate, reliableFromDate: null };
  if (position.effectiveDate === targetDate) return { status: 'ready', position, amountCents: position.amountCents, asOfDate: targetDate, reliableFromDate: position.effectiveDate };
  const expectedStart = nextCivilDate(position.effectiveDate);
  if (!expectedStart || coverageStartDate !== expectedStart || coverageEndDate !== targetDate) {
    return { status: 'incomplete_coverage', position, amountCents: null, asOfDate: targetDate, reliableFromDate: position.effectiveDate };
  }
  const amountCents = occurrences.reduce((total, item) => {
    if (item.date < expectedStart || item.date > targetDate || item.status === 'pending') return total;
    return total + (item.type === 'income' ? item.amountCents : -item.amountCents);
  }, position.amountCents);
  return { status: 'ready', position, amountCents, asOfDate: targetDate, reliableFromDate: position.effectiveDate };
};

export { nextCivilDate as getDayAfterBalancePosition };
